module.exports = __webpack_public_path__ + "img/member of.9719591d.png";